<div class="flex-wrapper flex-col height-100-pct">
  <div class="heading-1 padding-h flex-wrapper center-items padding-between">
    <i *ngIf="node.icon" [ngClass]="node.icon"></i>
    <span>{{node.label}}</span>
  </div>
  <div class="flex-main">
    <local-navigation [selectable]="false" [items]="node.children" scrollHeight="100%"
      navClass="a-card-nav a-local-nav p-grid" itemClass="a-card p-col-12 p-md-6 p-lg-3">
      <ng-template let-item>
        <div class="card-content" *ngIf="!cardTemplate; else cartTemp">
          <div class="card hoverable" (click)="selectCard($event,item)">
            <div class="body-2">{{item.type}}</div>
            <div class="heading-1 no-wrap">{{item.label}} ({{item.children?.length || 0}})</div>
            <div class="body-2">
              <i class="fa fa-trash link" (click)="delete($event,item)"></i>
            </div>
          </div>
        </div>
        <ng-template #cartTemp>
          <ng-container *ngTemplateOutlet="cardTemplate; context:{$implicit:item}"></ng-container>
        </ng-template>
      </ng-template>
    </local-navigation>
  </div>
</div>
<ng-content></ng-content>
